import React from "react";
import GridContainer from "../../../@jumbo/components/GridContainer";
import PageContainer from "../../../@jumbo/components/PageComponents/layouts/PageContainer";
import IntlMessages from "../../../@jumbo/utils/IntlMessages";

import Grid from "@material-ui/core/Grid";
import Divider from "@material-ui/core/Divider";

import GalleryElement from "@jumbo/Dashboards/Gallery/GalleryElement";

const breadcrumbs = [
  { label: <IntlMessages id={"sidebar.main"} />, link: "/" },
  { label: <IntlMessages id={"pages.gallery"} />, link: "/gallery" },
  { label: <IntlMessages id={"pages.createGallery"} />, isActive: true },
];

const CreateGellery = () => {
  return (
    <PageContainer
      heading={<IntlMessages id="pages.createGallery" />}
      breadcrumbs={breadcrumbs}
    >
      <GridContainer>
        <Grid item xs={12}>
          <Divider />
          <div style={{ marginTop: 24 }}>
            <GalleryElement />
          </div>
        </Grid>
      </GridContainer>
    </PageContainer>
  );
};

export default CreateGellery;
